var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#FFB3B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.19373 5.19373C4.93542 5.45204 4.93542 5.87085 5.19373 6.12915L7.06458 8L5.19373 9.87084C4.93542 10.1292 4.93542 10.548 5.19373 10.8063C5.45204 11.0646 5.87085 11.0646 6.12915 10.8063L8 8.93542L9.87084 10.8063C10.1292 11.0646 10.548 11.0646 10.8063 10.8063C11.0646 10.548 11.0646 10.1292 10.8063 9.87084L8.93542 8L10.8063 6.12915C11.0646 5.87085 11.0646 5.45204 10.8063 5.19373C10.548 4.93542 10.1292 4.93542 9.87084 5.19373L8 7.06458L6.12915 5.19373C5.87085 4.93542 5.45204 4.93542 5.19373 5.19373Z",
    fill: "#680012"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.svg";
export { ForwardRef as ReactComponent };